import React from 'react';
import SIcon from './SIcon';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faCheckCircle} fa />;

export default Icon;
